import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Website} from "../../website";
import {ActivityAction, ActivityStatus} from "../../../..//activities/activity";

@Component({
    selector: 'db-issue-item',
    templateUrl: './issue-item.component.html',
    styleUrls: ['./issue-item.component.scss'],
    standalone: false
})
export class IssueItemComponent {

  public ActivityAction = ActivityAction;
  public ActivityStatus = ActivityStatus;
  public loading: boolean;

  @Input() website: Website;
  @Input() securityIssue: any;
  @Input() issueIds?: string[];
  @Input() activeTab: string;

  @Output() toggled: EventEmitter<void>;
  @Output() doAction: EventEmitter<void>;
  @Output() restoreFile: EventEmitter<void>;



  constructor() {
    this.toggled = new EventEmitter<void>();
    this.doAction = new EventEmitter<void>();
    this.restoreFile = new EventEmitter<void>();
  }

  public doActionFn(): void {
    this.loading = true;
    this.doAction.emit();
  }

  public restoreFileFn(): void {
    this.restoreFile.emit();
  }

  public onItemToggled(activeTab): void {
    this.loading = false;
    this.toggled.emit(activeTab);
  }

  public stopEvent($event): void {
    $event.preventDefault();
    $event.stopPropagation();
  }

}
